import React from 'react'
import { StyledSecondaryButton } from './styledComponents'

export const SecondaryButton = ({ text, onClick, disabled, style }) => (
    <StyledSecondaryButton style={{'background-color': style == "purple" ? "#E2E3FE" : "#FFFFF", 'font-weight': style == "purple" ? "bold" : "500"}} variant="contained" {...{ onClick, disabled }}>
        {text}
    </StyledSecondaryButton>
)
